import { authSelectors } from 'ducks/auth'
import { useAddComponentToSystem } from 'hooks/components/useAddComponentToSystem'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { mapComponentTypesV2ToV1 } from 'util/misc'
import useActivatedComponents from '../../hooks/components/useActivatedComponents'
import type { HardwareSelectorDialogConfig } from './HardwareSelectorCore'

type handleSelectType = (component: any) => Promise<void> // TODO: add strong typing once endpoint is ready

const useHandleSelect = ({
  onClose,
  config,
  multiSelectMode,
}: {
  onClose(): void
  config: HardwareSelectorDialogConfig
  multiSelectMode: boolean
}): handleSelectType => {
  const history = useHistory()
  const location = useLocation()
  const role = useSelector(authSelectors.getCurrentRole)
  const componentType = mapComponentTypesV2ToV1(config.componentTypes[0])
  const activeComponentsData = useActivatedComponents({
    type: componentType,
    includeArchived: true,
  })

  const addComponentToSystem = useAddComponentToSystem()
  const onResolve = useCallback(
    (component) => {
      history.push(location.pathname)
    },
    [location.pathname]
  )

  return useCallback(
    (component) => {
      return addComponentToSystem({
        componentType: componentType,
        componentActivationId: component.model_id,
        componentId: component.model_id,
        activeComponentsData,
        targetUuids: config.targetUuids,
        slotKey: config.slotKey,
        quantity: componentType === 'other' ? 1 : undefined,
        closeDialog: multiSelectMode ? undefined : onClose,
        onSelect: config.onSelect,
        autoAdded: config.autoAdded,
        authored_by: role?.id ? `user-role:${role.id}` : undefined,
        selectedComponentCode: component.code,
        trackAddSuccess: true,
      }).then(onResolve)
    },
    [addComponentToSystem, onResolve, config, multiSelectMode, role?.id]
  )
}

export default useHandleSelect
